import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import Vue from "vue";

/**
 * Modo de edição do layout do painel em dispositivos sem mouse (tablets, totens,
 * TVs e notebooks com tela touch). Nesses dispositivos não existe hover, então os
 * ícones de edição ficam escondidos e só aparecem depois que o usuário toca na
 * tela e ativa o modo pelo botão "Editar layout".
 *
 * A detecção é feita pelo toque real (pointerType "touch"/"pen") e não pelo que o
 * navegador declara sobre o dispositivo: se a detecção falhar, nada aparece na
 * tela dos pacientes.
 */

// tempo que o botão "Editar layout" fica visível depois de um toque
export var BUTTON_VISIBLE_MS = 10000;

// tempo sem interação até o modo edição ser desligado sozinho
export var EDIT_MODE_IDLE_MS = 60000;
export var editLayoutState = Vue.observable({
  buttonVisible: false,
  active: false,
  lastPointerType: ""
});

// tela "Clique para ativar o painel" (main-layout.vue): o toque em "Ativar" serve
// para liberar o áudio do painel, não para editar o layout
var ACTIVATION_OVERLAY = ".btn-interaction";
var openPopups = new Set();
var buttonTimer = null;
var idleTimer = null;
var listeners = 0;
function isTouchPointer(pointerType) {
  return pointerType === "touch" || pointerType === "pen";
}
function showButton() {
  editLayoutState.buttonVisible = true;
  clearTimeout(buttonTimer);
  buttonTimer = setTimeout(function () {
    editLayoutState.buttonVisible = false;
  }, BUTTON_VISIBLE_MS);
}
function scheduleIdleExit() {
  clearTimeout(idleTimer);
  idleTimer = setTimeout(function () {
    // o modo não é desligado enquanto algum popup de edição estiver aberto
    if (openPopups.size > 0) {
      scheduleIdleExit();
      return;
    }
    exitEditMode();
  }, EDIT_MODE_IDLE_MS);
}
function registerInteraction(pointerType) {
  editLayoutState.lastPointerType = pointerType;
  if (editLayoutState.active) {
    scheduleIdleExit();
  } else if (isTouchPointer(pointerType)) {
    showButton();
  }
}
function isActivationTouch(event) {
  var target = event.target;
  return Boolean(target && target.closest && target.closest(ACTIVATION_OVERLAY));
}
function onPointerDown(event) {
  if (isActivationTouch(event)) {
    return;
  }
  registerInteraction(event.pointerType);
}

// notebook com tela touch: ao voltar a usar o mouse depois de um toque, o hover
// dos ícones precisa voltar a funcionar sem exigir um clique
function onPointerMove(event) {
  if (event.pointerType === "mouse" && editLayoutState.lastPointerType !== "mouse") {
    editLayoutState.lastPointerType = "mouse";
  }
}
function onTouchStart(event) {
  if (isActivationTouch(event)) {
    return;
  }
  registerInteraction("touch");
}
function onKeyDown() {
  if (editLayoutState.active) {
    scheduleIdleExit();
  }
}
export function enterEditMode() {
  editLayoutState.active = true;
  editLayoutState.buttonVisible = false;
  clearTimeout(buttonTimer);
  scheduleIdleExit();
}
export function exitEditMode() {
  editLayoutState.active = false;
  editLayoutState.buttonVisible = false;
  clearTimeout(buttonTimer);
  clearTimeout(idleTimer);
}

/**
 * Indica se a última interação foi por toque. Usado para ignorar toques nos
 * ícones de edição (invisíveis) quando o modo edição não está ativo.
 */
export function isTouchInteraction() {
  return isTouchPointer(editLayoutState.lastPointerType);
}
export function setPopupOpen(id, isOpen) {
  if (isOpen) {
    openPopups.add(id);
  } else {
    openPopups.delete(id);
  }
}
export function startTouchDetection() {
  listeners += 1;
  if (listeners > 1) {
    return;
  }
  if (window.PointerEvent) {
    window.addEventListener("pointerdown", onPointerDown, true);
    window.addEventListener("pointermove", onPointerMove, true);
  } else {
    // navegadores antigos de TV/totem sem Pointer Events
    window.addEventListener("touchstart", onTouchStart, true);
  }
  window.addEventListener("keydown", onKeyDown, true);
}
export function stopTouchDetection() {
  listeners = Math.max(0, listeners - 1);
  if (listeners > 0) {
    return;
  }
  window.removeEventListener("pointerdown", onPointerDown, true);
  window.removeEventListener("pointermove", onPointerMove, true);
  window.removeEventListener("touchstart", onTouchStart, true);
  window.removeEventListener("keydown", onKeyDown, true);
  exitEditMode();
}